import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  DEFAULT_START_SIGNING_PROFILE,
  DEFAULT_START_SIGNING_TEMPLATE,
} from '@app/transaction-builder/transaction-builder.constants';
import { EnvConfigService } from 'ngx-mat-esign360';
import {
  IStartSigningProfile,
  IStartSigningEnvConfig,
  IPartialStartSigningProfile,
} from '../model/env-config.model';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  constructor(
    private envConfig: EnvConfigService<IStartSigningEnvConfig>,
    private route: ActivatedRoute
  ) {}

  getProfile(profileId: string): IStartSigningProfile | null {
    const profile = this.envConfig.data.startSigningProfiles[profileId];
    return this.completeProfile(profile);
  }

  getCurrentProfileId(): string {
    const queryParams = this.route.snapshot.queryParams;
    return queryParams.customProfile || this.envConfig.data.defaultStartSigningProfile;
  }

  getCurrentProfile(): IStartSigningProfile {
    const profileId = this.getCurrentProfileId();

    if (this.doesProfileExist(profileId)) {
      return this.getProfile(profileId);
    } else {
      console.warn(`Profile "${profileId}" not found in configuration`);

      if (this.doesAnyProfileExist()) {
        return this.getFirstProfile();
      } else {
        console.warn('No profile was specified in configuration');
        return DEFAULT_START_SIGNING_PROFILE;
      }
    }
  }

  private doesProfileExist(profileId: string): boolean {
    return !!this.envConfig.data.startSigningProfiles?.[profileId];
  }

  private doesAnyProfileExist(): boolean {
    return (
      this.envConfig.data.startSigningProfiles &&
      Object.keys(this.envConfig.data.startSigningProfiles).length > 0
    );
  }

  private getFirstProfile(): IStartSigningProfile {
    const firstProfile = Object.values(this.envConfig.data.startSigningProfiles)[0];
    return this.completeProfile(firstProfile);
  }

  private completeProfile(profile: IPartialStartSigningProfile): IStartSigningProfile {
    const updatedProfile = {
      ...DEFAULT_START_SIGNING_PROFILE,
      ...profile,
    };

    return profile.template
      ? {
          ...updatedProfile,
          template: {
            ...DEFAULT_START_SIGNING_TEMPLATE,
            ...profile.template,
          },
        }
      : (updatedProfile as IStartSigningProfile);
  }
}
